import basicResourceApi from 'providers/basicResourceProvider'

export const getSchoolYears = async () => {
  const data = await basicResourceApi.get('/schoolYears?per_page=-1')
  return data
    .sort(({ year: yearA }, { year: yearB }) => yearB - yearA)
    .map(({ id, year, ...schoolYear }) => ({ value: id, label: year, ...schoolYear }))
}
